import {User} from 'components/customer/Auth/store/userSlice';

export const checkTutorialIsDisabled = (key: string, user: User) => {
    if (user.tutorialOptions && user.tutorialOptions.hasOwnProperty(key)) {
        return user.tutorialOptions[String(key)];
    }

    return true;
};
